
import React, { useState } from "react";
import {FaCircle} from "react-icons/fa";

const ProfileDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("active");

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleStatusChange = (status) => {
    setSelectedStatus(status);
    setIsOpen(!isOpen);
    // Send the selectedStatus value to your API here
  };

  const getStatusCircleColor = (status) => {
    switch (status) {
      case "active":
        return "green";
      case "away":
        return "orange"; // Change to the color you want
      case "do_not_disturb":
        return "red"; // Change to the color you want
      case "invisible":
        return "gray"; // Change to the color you want
      default:
        return "green"; // Default color
    }
  };

  return (
    <div className="user-profile-dropdown">
      <div className="user-info" onClick={toggleDropdown}>
      <FaCircle color={getStatusCircleColor(selectedStatus)} />
      </div>
      {isOpen && (
        <div className="drop-menu">
          <ul>
            <li
              onClick={() => handleStatusChange("active")}
              className={selectedStatus === "active" ? "active" : ""}
            >
              Active
            </li>
            <li
              onClick={() => handleStatusChange("away")}
              className={selectedStatus === "away" ? "active" : ""}
            >
              Away
            </li>
            <li
              onClick={() => handleStatusChange("do_not_disturb")}
              className={selectedStatus === "do_not_disturb" ? "active" : ""}
            >
              Do Not Disturb
            </li>
            <li
              onClick={() => handleStatusChange("invisible")}
              className={selectedStatus === "invisible" ? "active" : ""}
            >
              Invisible
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default ProfileDropdown;